(function () {
  'use strict';

  function getRoutineTimeBucket(p) {
    var raw = String((p && (p.application_time || p.usage_time || p.recommended_time || p.time_of_use)) || '').toUpperCase();
    var both = raw.includes('BOTH') || raw.includes('AM/PM');
    var am = raw.includes('AM') || raw.includes('MORNING') || raw.includes('DAY');
    var pm = raw.includes('PM') || raw.includes('NIGHT') || raw.includes('EVENING');
    if (both || (am && pm)) return 'both';
    if (am) return 'am';
    if (pm) return 'pm';
    return 'unknown';
  }

  function getApplicationTimeSortRank(p) {
    var raw = String((p && (p.application_time || p.usage_time || p.recommended_time || p.time_of_use)) || '').toUpperCase();
    if (!raw.trim()) return 99;
    var both = raw.includes('BOTH') || raw.includes('AM/PM');
    var am = raw.includes('AM') || raw.includes('MORNING') || raw.includes('DAY');
    var pm = raw.includes('PM') || raw.includes('NIGHT') || raw.includes('EVENING');
    if (both) return 1;
    if (am && !pm) return 0;
    if (pm && !am) return 2;
    if (am && pm) return 1;
    return 99;
  }

  function getGroupTimeBucket(groupEntries) {
    if (!groupEntries || !groupEntries.length) return 'unknown';
    var buckets = groupEntries.map(function (e) { return getRoutineTimeBucket(e.p); });
    var hasAm = buckets.some(function (b) { return b === 'am'; });
    var hasPm = buckets.some(function (b) { return b === 'pm'; });
    var hasBoth = buckets.some(function (b) { return b === 'both'; });
    if (hasBoth || (hasAm && hasPm)) return 'both';
    if (hasAm) return 'am';
    if (hasPm) return 'pm';
    return 'unknown';
  }

  function formatRoutineCategoryTitle(apiKey, timeBucket) {
    if (!apiKey || typeof apiKey !== 'string') return '';
    var raw = apiKey.trim();
    var k = raw.toLowerCase().replace(/[\s-]+/g, '_');

    var timeLabel = '';
    if (timeBucket === 'am') timeLabel = 'Morning';
    else if (timeBucket === 'pm') timeLabel = 'Night';
    else if (!timeBucket || timeBucket === 'unknown') {
      if (k.includes('am') || k.includes('morning') || k.includes('_day') || k.endsWith('_am')) timeLabel = 'Morning';
      else if (k.includes('pm') || k.includes('night') || k.includes('evening') || k.endsWith('_pm')) timeLabel = 'Night';
    }

    var isPreCleanser = (k.includes('pre') && (k.includes('cleans') || k.includes('cleanse'))) || k === 'pre_cleanser' || k === 'precleanser';
    if (isPreCleanser) return 'Pre-cleanser';

    var isFaceWash = (k.includes('face') && (k.includes('wash') || k.includes('cleans'))) || k.includes('face_wash') || k === 'cleanser';
    if (isFaceWash && !isPreCleanser) return timeLabel ? ('Step 1 ' + timeLabel + ' Face Wash') : 'Step 1 Face Wash';

    if (k.includes('serum')) return timeLabel ? ('Step 2 ' + timeLabel + ' Serum') : 'Step 2 Serum';
    if (k.includes('moistur')) return timeLabel ? ('Step 3 ' + timeLabel + ' Moisturiser') : 'Step 3 Moisturiser';
    if (k.includes('sun')) return 'Step 4 Sunscreen';

    return raw.split('_').map(function (w) {
      if (!w) return '';
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  function sortAndLimitRoutineProducts(items) {
    if (!items || !items.length) return items;
    var rank = function (entry) { return getApplicationTimeSortRank(entry.p); };
    var normName = function (entry) {
      return String((entry && entry.p && (entry.p.product_name || entry.p.name || entry.p.title)) || '')
        .trim()
        .toLowerCase()
        .replace(/\s+/g, ' ');
    };
    var sorted = items.slice().sort(function (a, b) { return rank(a) - rank(b); });
    var am = sorted.filter(function (x) { return rank(x) === 0; });
    var both = sorted.filter(function (x) { return rank(x) === 1; });
    var pm = sorted.filter(function (x) { return rank(x) === 2; });

    if (am.length >= 2) {
      var amDifferentNames = [];
      var seenAmNames = new Set();
      for (var i = 0; i < am.length; i++) {
        var n = normName(am[i]);
        if (n && !seenAmNames.has(n)) {
          amDifferentNames.push(am[i]);
          seenAmNames.add(n);
        }
        if (amDifferentNames.length >= 2) break;
      }
      if (amDifferentNames.length >= 2) return amDifferentNames.slice(0, 2);
    }

    var out = [];
    if (am.length) out.push(am[0]);
    if (out.length < 2 && pm.length) out.push(pm[0]);
    if (out.length < 2 && both.length) out.push(both[0]);
    if (out.length < 2) {
      sorted.forEach(function (x) {
        if (out.length < 2 && out.indexOf(x) === -1) out.push(x);
      });
    }
    return out.slice(0, 2);
  }

  function sortAndLimitSerumProducts(items) {
    if (!items || !items.length) return items;
    var rank = function (entry) { return getApplicationTimeSortRank(entry.p); };
    var sorted = items.slice().sort(function (a, b) { return rank(a) - rank(b); });
    var am = sorted.filter(function (x) { return rank(x) === 0; }).slice(0, 2);
    var pm = sorted.filter(function (x) { return rank(x) === 2; }).slice(0, 2);
    var both = sorted.filter(function (x) { return rank(x) === 1; });

    var out = [];
    am.forEach(function (x) { out.push(x); });
    pm.forEach(function (x) { out.push(x); });
    if (out.length < 4) {
      both.forEach(function (x) {
        if (out.length < 4 && out.indexOf(x) === -1) out.push(x);
      });
    }
    if (out.length < 4) {
      sorted.forEach(function (x) {
        if (out.length < 4 && out.indexOf(x) === -1) out.push(x);
      });
    }
    return out.slice(0, 4);
  }

  function buildSerumDisplayGroups(entries) {
    if (!entries || !entries.length) return [];
    var am = [];
    var pm = [];
    var other = [];
    entries.forEach(function (entry) {
      var t = getRoutineTimeBucket(entry.p);
      if (t === 'am') am.push(entry);
      else if (t === 'pm') pm.push(entry);
      else other.push(entry);
    });
    var groups = [];
    if (am.length) groups.push(am.slice(0, 2));
    if (pm.length) groups.push(pm.slice(0, 2));
    if (!groups.length && other.length) {
      for (var i = 0; i < other.length; i += 2) groups.push(other.slice(i, i + 2));
    }
    return groups;
  }

  function getComparableProductName(p) {
    return String((p && (p.product_name || p.name || p.title)) || '')
      .toLowerCase()
      .replace(/\b(am|pm|day|night|morning|evening)\b/g, ' ')
      .replace(/[^\w\s]/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function shouldSplitIntoIndividualCards(entries) {
    if (!entries || entries.length !== 2) return false;
    var t1 = getRoutineTimeBucket(entries[0].p);
    var t2 = getRoutineTimeBucket(entries[1].p);
    if ((t1 === 'am' && t2 === 'pm') || (t1 === 'pm' && t2 === 'am')) return true;

    var n1 = getComparableProductName(entries[0].p);
    var n2 = getComparableProductName(entries[1].p);
    if (!n1 || !n2 || n1 !== n2) return false;
    var amLike1 = t1 === 'am' || t1 === 'both';
    var pmLike1 = t1 === 'pm' || t1 === 'both';
    var amLike2 = t2 === 'am' || t2 === 'both';
    var pmLike2 = t2 === 'pm' || t2 === 'both';
    return (amLike1 && pmLike2) || (pmLike1 && amLike2);
  }

  function shouldShowEitherOneSeparator(entries) {
    return !!(entries && entries.length === 2);
  }

  window.ChatbotProductsRoutineUtils = {
    getRoutineTimeBucket: getRoutineTimeBucket,
    getApplicationTimeSortRank: getApplicationTimeSortRank,
    getGroupTimeBucket: getGroupTimeBucket,
    formatRoutineCategoryTitle: formatRoutineCategoryTitle,
    sortAndLimitRoutineProducts: sortAndLimitRoutineProducts,
    sortAndLimitSerumProducts: sortAndLimitSerumProducts,
    buildSerumDisplayGroups: buildSerumDisplayGroups,
    getComparableProductName: getComparableProductName,
    shouldSplitIntoIndividualCards: shouldSplitIntoIndividualCards,
    shouldShowEitherOneSeparator: shouldShowEitherOneSeparator
  };
})();

